export { default } from "./time-display";
